(() => {
  'use strict';
  const feeVariant = 50691993468993;
  const answerKey = 'AI generated artwork';
  const groupKey = '_rogue_ai_group';
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let syncing;
  async function request(path, data) {
    const response = await nativeFetch(root + path, data ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)} : {cache:'no-store'});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update the artwork fee. Please try again.');
    return result;
  }
  async function reconcile() {
    let cart = await request('cart.js');
    const parents = cart.items.filter(item => item.variant_id !== feeVariant && item.properties?.[answerKey] === 'Yes');
    const fees = cart.items.filter(item => item.variant_id === feeVariant);
    const groups = new Set(parents.map(item => item.properties?.[groupKey]).filter(Boolean));
    const seen = new Set();
    const updates = {};
    for (const fee of fees) {
      const group = fee.properties?.[groupKey];
      if (!groups.has(group) || seen.has(group)) updates[fee.key] = 0;
      else { seen.add(group); if (fee.quantity !== 1) updates[fee.key] = 1; }
    }
    if (Object.keys(updates).length) cart = await request('cart/update.js', {updates});
    const missing = parents.filter(item => item.properties?.[groupKey] && !seen.has(item.properties[groupKey]));
    if (missing.length) {
      await request('cart/add.js', {items:missing.map(item => ({id:feeVariant,quantity:1,properties:{[groupKey]:item.properties[groupKey], 'For sticker item':item.product_title, 'Sticker size':item.variant_title || 'Standard'}}))});
      cart = await request('cart.js');
    }
    return {cart, changed:!!Object.keys(updates).length || !!missing.length};
  }
  function sync() {
    if (!syncing) syncing = reconcile().finally(() => { syncing = null; });
    return syncing;
  }
  function error(fieldset, error) {
    const el = fieldset.querySelector('[data-ai-error]');
    el.textContent = error.message;
    el.hidden = false;
  }
  function prepare(form, event) {
    if (!form?.querySelector('[data-rogue-ai-artwork]')) return;
    if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    const answer = form.querySelector('[name="properties[AI generated artwork]"]:checked');
    if (!answer) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    let hidden = form.querySelector('[name="properties[_rogue_ai_group]"]');
    if (answer.value === 'Yes' && !hidden) {
      hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'properties[_rogue_ai_group]';
      hidden.value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`; form.append(hidden);
    }
    if (answer.value === 'No') hidden?.remove();
  }
  document.addEventListener('submit', event => prepare(event.target,event),true);
  document.addEventListener('click', event => {
    const button = event.target.closest('button[type="submit"],input[type="submit"]');
    if (button?.form) prepare(button.form,event);
  },true);
  function isAdd(url) { return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url)); }
  window.fetch = async function(input, init) {
    const response = await nativeFetch(input,init);
    if (isAdd(typeof input === 'string' ? input : input?.url) && response.ok) await sync();
    if (/\/cart\/(change|update|clear)(?:\.js)?(?:\?|$)/.test(String(typeof input === 'string' ? input : input?.url)) && response.ok) setTimeout(onCart, 150);
    return response;
  };
  if (window.jQuery) {
    const $ = window.jQuery;
    const nativeAjax = $.ajax;
    $.ajax = function(url, options) {
      const settings = typeof url === 'object' ? {...url} : {...options,url};
      if (!isAdd(settings.url)) return nativeAjax.apply(this,arguments);
      const deferred = $.Deferred();
      const success = settings.success; const failure = settings.error; const complete = settings.complete;
      delete settings.success; delete settings.error; delete settings.complete;
      const xhr = nativeAjax.call(this,settings);
      xhr.done(function(data,status,jqXHR) {
        const context = this;
        sync().then(() => {
          if (success) success.call(context,data,status,jqXHR);
          deferred.resolveWith(context,[data,status,jqXHR]);
          if (complete) complete.call(context,jqXHR,status);
        }).catch(err => {
          window.alert('Your stickers were added. Open your cart to finish adding the artwork fee.');
          window.location.assign(root + 'cart');
          deferred.rejectWith(context,[jqXHR,'error',err]);
        });
      });
      xhr.fail(function(...args) {
        if (failure) failure.apply(this,args);
        deferred.rejectWith(this,args);
        if (complete) complete.call(this,args[0],args[1]);
      });
      return deferred.promise(xhr);
    };
  }
  let checkoutReady = false;
  async function checkout(event) {
    if (checkoutReady) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const control = event.target.closest('[name="checkout"],a[href*="/checkout"],button') || event.target;
    if (control.dataset.aiChecking) return;
    control.dataset.aiChecking = 'true';
    try {
      await sync();
      checkoutReady = true;
      if (control.form && control.type === 'submit') control.form.requestSubmit(control);
      else control.click();
      setTimeout(() => { checkoutReady = false; delete control.dataset.aiChecking; }, 0);
    }
    catch (err) { window.alert(err.message); delete control.dataset.aiChecking; }
  }
  document.addEventListener('click', event => {
    if (event.target.closest('[name="checkout"],a[href^="/checkout"],a[href^="' + root + 'checkout"]')) checkout(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkout(event);
  }, true);
  function onCart() {
    if (!window.location.pathname.replace(/\/$/,'').endsWith('/cart')) return;
    sync().then(result => { if (result.changed) window.location.reload(); }).catch(err => {
      const message = document.createElement('p'); message.setAttribute('role','alert'); message.textContent = err.message;
      document.querySelector('[data-cart]')?.prepend(message);
    });
  }
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (/\/cart\/(change|update|clear)(?:\.js)?(?:\?|$)/.test(String(url))) {
      this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) setTimeout(onCart, 150); }, {once:true});
    }
    return nativeOpen.apply(this, arguments);
  };
  onCart();
  document.addEventListener('cart:updated', onCart);
  document.addEventListener('product-form:cart:update', onCart);
  if (window.jQuery) window.jQuery(document).ajaxComplete((event, xhr, settings) => {
    if (/\/cart\/(change|update)(\.js)?(?:\?|$)/.test(settings.url || '')) onCart();
  });
})();
